import { useMediaQuery } from "@material-ui/core";

export function useBreakpoints() {
  const breakpointSm = useMediaQuery((theme: any) =>
    theme.breakpoints.up("sm")
  );
  const breakpointMd = useMediaQuery((theme: any) =>
    theme.breakpoints.up("md")
  );
  const breakpointLg = useMediaQuery((theme: any) =>
    theme.breakpoints.up("lg")
  );
  const breakpointXl = useMediaQuery((theme: any) =>
    theme.breakpoints.up("xl")
  );

  return {
    sm: breakpointSm,
    md: breakpointMd,
    lg: breakpointLg,
    xl: breakpointXl,
  };
}
